import EfbService from "../../services/EFB.service";
// import http from "../../http";

const state = {

    // AirportsList: [],
    isActiveModal: false,
    // UpdateAirportList: [],

    inpectorviewlist:[],
    inspectorviewDataByUid : null,
    deviceslistByuuid:[],
    heartbeatsignalsByuuid:[],

    DeviceSummaryList:[],
    ReqListOdReqTypeAndDevice : [],

    // EFBOccSideLogs

    EFBOccSideLogs : [],

};

const mutations = {

    set_inpectorviewlist(state, payload) {
        state.inpectorviewlist = payload;
    },
    set_inspectorviewByDeviceUid(state,payload){
        state.inspectorviewDataByUid = payload;
    },
    set_clear_inpectorviewlist(state) {
        state.inpectorviewlist = [];
    },

    set_deviceslistByuuid(state, payload) {
        state.deviceslistByuuid = payload;
    },
    set_clear_deviceslistByuuid(state) {
        state.deviceslistByuuid = [];
    },

    set_heartbeatsignalsByuuid(state, payload) {
        state.heartbeatsignalsByuuid = payload;
    },
    set_clear_heartbeatsignalsByuuid(state) {
        state.heartbeatsignalsByuuid = [];
    },

    set_DeviceSummaryList(state,payload){
        state.DeviceSummaryList = payload;
    },

    set_ReqListOdReqTypeAndDevice(state,payload)
    {
        state.ReqListOdReqTypeAndDevice = payload;
    },

    set_clear_ReqListOdReqTypeAndDevice(state) {
        state.ReqListOdReqTypeAndDevice = [];
    },

    set_ListOfEFBOccSideLogs(state,payload){
        state.EFBOccSideLogs = payload;

    },

    clear_ListOfEFBOccSideLogs(state){
        state.EFBOccSideLogs = [];
    }

};

const actions = {


    async GetInspectorviewGetByUid({commit},payload)
    {

        // console.log("Device uid module payload : "+ payload);
      const inspectorviewByUid = await EfbService.GetDeviceByUidInspectorview(payload);
      await commit("set_inspectorviewByDeviceUid",inspectorviewByUid);
      return inspectorviewByUid;
    },

    async Getinspectorviewlist({commit}) {
        await commit("set_clear_inpectorviewlist");
        const inpectorviewlist = await EfbService.Getinpectorviewlist();
        await commit("set_inpectorviewlist", inpectorviewlist);
        return inpectorviewlist;
    },

    async GetdeviceslistByuuid({commit},payload) {
        await commit("set_clear_deviceslistByuuid")
        const deviceslistByuuid = await EfbService.GetDevices(payload);
        await commit("set_deviceslistByuuid", deviceslistByuuid);
        return deviceslistByuuid;
    },

    async GetheartbeatsignalsByuuid({commit},payload) {
        await commit("set_clear_heartbeatsignalsByuuid");
        const hearbeatsignalsByuuid = await EfbService.GetHeartBeatSignals(payload);
        await commit("set_heartbeatsignalsByuuid", hearbeatsignalsByuuid);
        return hearbeatsignalsByuuid;
    },

    async GetSummaryListOfDevice({commit}) {
        const summaryList = await EfbService.GetDeviceSummaryList();
        await commit("set_DeviceSummaryList", summaryList);
        return summaryList;
    },

    // device_uuid,reqType,date1,date2
    async GetReqListOdReqTypeAndDevice({commit},payload)
    {
        const ReqList = await EfbService.GetReqListOfReqTypeAndDevice(payload.device_uuid,payload.reqType,payload.date1,payload.date2);
        await commit("set_ReqListOdReqTypeAndDevice", ReqList);
        return ReqList;
    },

    // device_uuid,reqType,fkeyforzip,whoRequestedLast,date1,date2
    async GetIpadRequestFile_MakeOneRequest(payload)
    {
        // console.log(payload.device_uuid+" GetIpadRequestFile_MakeOneRequest MODULE "+payload.reqType+" "+payload.fkeyforzip+" "+payload.whoRequestedLast+payload.date1+payload.date2+ "uid aldımı GetIpadRequestFile_MakeOneRequest");
        const Req = await EfbService.GetIpadRequestFile_MakeRequest(payload.device_uuid,payload.reqType,payload.fkeyforzip,payload.whoRequestedLast,payload.date1,payload.date2);

        return Req;
    },

    clear_ReqListOdReqTypeAndDevice({commit})
    {
        commit("set_clear_ReqListOdReqTypeAndDevice");
    },

    async GetWeeklyRangedListOfEFBOccSideLogs({commit},payload)
    {
        // console.log("Module DayOrigin", payload);
        await commit("clear_ListOfEFBOccSideLogs");
        const OccSideLogs_List = await EfbService.GetEFBOccSideLogsWeeklyRanged(payload);
        await commit("set_ListOfEFBOccSideLogs", OccSideLogs_List);
        return OccSideLogs_List;
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
